import { useEffect, useRef, useState } from "react";

const Calendar = () => {
    //
    // const [calendlyUrl, setCalendlyUrl] = useState(null);
    const initializedRef = useRef(false);

    //     useEffect(() => {
    //         // Step 1: Fetch the Calendly URL from the backend
    //         const fetchCalendlyUrl = async () => {
    //             try {
    //                 const res = await fetch("/api/calendly-link"); // Adjust if your API path is different
    //                 const data = await res.json();
    //                 console.log("Fetched Calendly URL:", data.url);
    //                 setCalendlyUrl(data.url);
    //             } catch (err) {
    //                 console.error("Failed to fetch Calendly URL:", err);
    //             }
    //         };
    // 
    //         fetchCalendlyUrl();
    //     }, []);

    useEffect(() => {
        // if (!calendlyUrl) return; // Don't run until we have the URL

        const scriptId = "calendly-widget-script";
        const calendlyUrl = "https://calendly.com/halfsermonministries"
        // const calendlyUrl = process.env.CALENDLY_LINK;


        const loadCalendly = () => {
            if (!initializedRef.current && window.Calendly) {
                window.Calendly.initInlineWidget({
                    url: calendlyUrl,
                    parentElement: document.getElementById("calendly-embed"),
                });
                initializedRef.current = true;
            }
        };

        // If Calendly is already loaded, initialize immediately
        if (window.Calendly) {
            loadCalendly();
        } else {
            // If not, load the script once
            if (!document.getElementById(scriptId)) {
                const script = document.createElement("script");
                script.id = scriptId;
                script.src = "https://assets.calendly.com/assets/external/widget.js";
                script.async = true;
                script.onload = loadCalendly;
                document.body.appendChild(script);
            } else {
                // If the script is already there but Calendly isn't loaded yet
                document
                    .getElementById(scriptId)
                    .addEventListener("load", loadCalendly);
            }
        }
    }, []);
    // }, [calendlyUrl]); // Run this effect **only when calendlyUrl is set**

    return (
        <div
            id="calendly-embed"
            style={{ minWidth: "320px", height: "700px" }}
        ></div>
    );
};

export default Calendar;